<!-- <div id="appHeader">
  <nav class="navbar navbar-expand-lg navbar-dark navbar-absolute px-lg-3 px-md-3 px-sm-3">
    <a class="navbar-brand " routerLink="/">
      <img src="./assets/img/logo_small.png" class="d-inline-block align-middle img-fluid w-25 ms-4 me-2"
        alt="brand_logo" />
      TILA Top up
    </a>
  </nav>
</div> -->
<app-header [showTopbar]="false"></app-header>
<div class="container-fluid">
  <div class="session-activity-container">
    <div class="row justify-content-center align-items-center">
      <div class="col-lg-4 col-md-5 col-sm-4 col-xs-12 align-self-center">
        <div class="login-blk">
          <mat-card class="p-4">
            <h4
              class="form-title text-start  mb-4 px-2"
              translate
              >pages.login.forgotPasswordtitle
            </h4>
            <mat-card-subtitle class="px-2" translate
              >pages.login.wesendOTPtomobilecall</mat-card-subtitle
            >
            <form [formGroup]="forgotForm" (submit)="submit()">
              <h4 class="form-field-tile mb-2 " translate>
                pages.login.enterUsername
              </h4>

              <mat-form-field class="form-field d-block" appearance="outline">
                <input
                  matInput
                  formControlName="userName"
                  required
                  placeholder="Ex. John123"
                />
              </mat-form-field>
              <mat-error
                *ngIf="
                  forgotForm.controls.userName.touched &&
                  forgotForm.controls.userName.invalid
                "
              >
                <span *ngIf="forgotForm.controls.userName.errors.required"
                  >{{ 'pages.placeholders.Thisfieldismandatory' | translate }}</span
                >
              </mat-error>
              <label
                ><b translate>pages.login.receiveCode</b> <span class="required">*</span>
              </label>
              <mat-radio-group [formControl]="notification">
                <mat-radio-button color="primary" value="sms"
                  ><span><b translate>pages.login.text</b></span></mat-radio-button
                >
                <mat-radio-button color="primary" value="email"
                  ><span><b translate>pages.login.email</b></span></mat-radio-button
                >
              </mat-radio-group>
              <button
                mat-raised-button
                color="primary"
                type="submit"
                class="d-block mx-auto w-100"
              >
                <span translate class="translate">pages.login.proceed</span>
              </button>
            </form>
          </mat-card>
        </div>
      </div>
    </div>
  </div>
</div>
